module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAD8SURBVGiB7dO9TsMwFIbhVx0amV5nkrGCC4OhLLRZuDAoQ3IEclPIjx3b6HukI2VIrPPKCoiIiIhIyaphinYA3oEz4BLvspgDLsB1mCJjHP3iV2+KiqmAV24jbE4U8M/4N/EJtMBxeC7iZu5FmCJi/oowWcdMjTAtGcaMRTQTvssqZmmEySJmbYRJGhMqwjQkiAkdYfyYNyLGxIowm8TEjjBRY8Yi6lCHj4gSs3WECRrjhgO2jjBBYlJHmJoVMblEmEUxfsQHaSPMrJhcI8zkmAeg+/Hi40YLzvHE934d/c6j9sALed2Erwae6Xf91S7+LquVsKOIiIjIv/EF0VWv8W7xlc4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/ResultLayerItem/images/arrow.png
// module id = 1567
// module chunks = 0